import { NSValidation } from './../../classes/NSValidation';
import { BaseComponent } from './../base/base.component';
import { Component, OnInit } from '@angular/core';
declare var bootbox:any;
@Component({
  selector: 'app-sub-category-ne',
  template: require('./sub-category-ne.component.html')
})
export class SubCategoryNeComponent extends BaseComponent implements OnInit {

  public subcategoryId = -1;
  public subcategory = {
    name: "",
    description: "",
    category: {},
    categoryId: -1
  };

  public categories = [];

  ngOnInit() {
    super.ngOnInit();
    this.loadCategories();
  }

  public loadCategories() {
    this.busy = this.lsApi.getCategories().subscribe(resp => {
        if(resp.status) {
            this.categories = resp.data;
        }
    },
    error => {
        console.log(error);
    });
  }


  public routeParamsUpdated() {
    this.subcategoryId = this.default(this.currentRouteParams["subcatId"],-1);
    if(this.subcategoryId>0)
      this.loadSubCategoryById();
    else 
      this.subcategoryId = -1;
  }

  public loadSubCategoryById() {
      this.busy = this.lsApi.getSubCategoryById(this.subcategoryId).subscribe(resp => {
        if(resp.status) {
            this.subcategory = resp.data[0];
        }
    },
    error => {
        console.log(error);
    });
  }

  public save() {
    var validate:NSValidation = new NSValidation();

    var errorMessage = "";
    if(validate.isEmpty(this.subcategory.name)) {
        errorMessage = "Please provide a name for this category";
    }
    if(this.subcategory.categoryId==null || this.subcategory.categoryId <=0 ) {
        errorMessage = "Please select a parent category";
    }

    if(errorMessage!="") {
        bootbox.alert(errorMessage);
    }
    else {
        this.busy = this.lsApi.saveSubCategory(this.subcategoryId, this.subcategory.categoryId, this.subcategory.name, this.subcategory.description).subscribe(resp => {
            if(resp.status) {
                this.router.navigate(['/admin/sub-categories']).then(() => {
                  this.appToast.success("Sub-Category Successfully Saved","Sub-Category Saved")
                })
            }
        },
        error => {
            console.log(error);
        });
    }
  }

  public cancel() {
    this.router.navigate(['/admin/sub-categories']);
  }

  public delete() {

    bootbox.confirm({message:"Do you want to delete '" + this.subcategory.name + "' category and all it's data?<br><small>All their data will be lost. This cannot be undone.</small>",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {

          this.busy = this.lsApi.deleteSubCategoryById(this.subcategoryId).subscribe(resp => {
              if(resp.status) {
                  this.router.navigate(['/admin/sub-categories']).then(() => {
                    this.appToast.success("Sub-Category Successfully Deleted","Sub-Category Deleted")
                  })
              }
          },
          error => {
              console.log(error);
          });

        }
      }});
  }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/sub-category-ne/sub-category-ne.component.ts